export const parseURLParams = (url?: string | URL) => {
  url = url ?? window.location.href;
  url = new URL(url);
  const searchParams = new URLSearchParams(url.search);
  const params: Record<string, string> = {};
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  return params;
};

export const getUrlPath = () => {
  const currentUrl = document.URL.split('#');
  if (currentUrl.length < 2) {
    return [''];
  }
  const anchor = currentUrl[1].split('/');
  return anchor;
};